import { Container } from "react-bootstrap";
import "./css/style.css";
export default function Footer(params) {
    return (
        <footer className="footer">
            <Container className="flex">
                <a className="header_logo" href="/">
                    <img
                        src="/logo_hom.png"
                        alt="Аренда73"
                    />
                    <div className="header_logo_text">
                        <span className="header_logo_big">
                            КВАРТИРЫ
                        </span>
                        <span className="header_logo_min">
                            ПОСУТОЧНО
                        </span>
                    </div>
                </a>
                <nav className="nav">
                    <ul className="nav_box flex">
                        {/* <li>
                            <a
                                className="link flex t20"
                                href=""
                            >
                                Карта сайта
                            </a>
                        </li>
                        <li>
                            <a
                                className="link flex t20"
                                href=""
                            >
                                Контакты
                            </a>
                        </li> */}

                        <li>
                            <div className="soc flex">
                                <a
                                    target="_blanc"
                                    href="https://api.whatsapp.com/send/?phone=79378892636&text=Здравствуйте%2C+хотелось+бы+забронировать+квартиру&type=phone_number&app_absent=0"
                                    className="soc_item"
                                >
                                    <svg
                                        width="31"
                                        height="31"
                                        viewBox="0 0 31 31"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="15.8799"
                                            cy="15.7796"
                                            r="15"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M22.4321 9.22137C21.6572 8.44507 20.7352 7.82952 19.7195 7.41038C18.7039 6.99125 17.6148 6.77686 16.5153 6.77964C11.9048 6.77964 8.15164 10.5141 8.14978 15.1045C8.14978 16.5716 8.5346 18.0034 9.26605 19.2665L8.0799 23.5796L12.5142 22.4214C13.7408 23.0859 15.115 23.4343 16.5116 23.4349H16.5153C21.1248 23.4349 24.878 19.7005 24.8799 15.1101C24.883 14.0162 24.6683 12.9326 24.2482 11.9219C23.828 10.9111 23.2108 9.99328 22.4321 9.22137ZM16.5153 22.03H16.5125C15.2672 22.0301 14.0448 21.6967 12.9736 21.0646L12.7202 20.9144L10.0888 21.6016L10.7904 19.0486L10.6255 18.787C9.92928 17.6839 9.56071 16.4072 9.56235 15.1045C9.56422 11.2894 12.6829 8.18551 16.5181 8.18551C17.4315 8.1835 18.3362 8.36179 19.1798 8.71007C20.0235 9.05836 20.7894 9.56972 21.4332 10.2146C22.0804 10.8563 22.5935 11.6194 22.9426 12.4597C23.2917 13.3 23.4701 14.2008 23.4673 15.1101C23.4654 18.9252 20.3468 22.03 16.5153 22.03ZM20.3291 16.847C20.1194 16.7422 19.0926 16.2396 18.9006 16.17C18.7096 16.1005 18.5708 16.0662 18.431 16.2739C18.2913 16.4816 17.8906 16.95 17.7685 17.0891C17.6465 17.2282 17.5244 17.2449 17.3157 17.141C17.107 17.0371 16.4333 16.8173 15.6348 16.1088C15.0133 15.5571 14.594 14.8764 14.4719 14.6677C14.3498 14.4591 14.4589 14.3469 14.5641 14.243C14.6583 14.1503 14.7729 14 14.8772 13.8786C14.9816 13.7571 15.0161 13.6708 15.0859 13.5317C15.1558 13.3926 15.1213 13.2711 15.0682 13.1673C15.0161 13.0625 14.5977 12.0387 14.4234 11.6223C14.2548 11.2189 14.0824 11.2727 13.9538 11.2671C13.8207 11.2617 13.6874 11.2592 13.5541 11.2597C13.4481 11.2624 13.3438 11.2868 13.2478 11.3315C13.1517 11.3762 13.066 11.4402 12.996 11.5194C12.804 11.728 12.2645 12.2306 12.2645 13.2544C12.2645 14.2782 13.0137 15.2677 13.118 15.4068C13.2224 15.5459 14.5921 17.6464 16.6886 18.5478C17.188 18.762 17.5775 18.89 17.8803 18.9864C18.3807 19.145 18.8363 19.1218 19.1969 19.069C19.5985 19.0096 20.4334 18.5663 20.6077 18.0804C20.7819 17.5945 20.7819 17.1781 20.7297 17.0909C20.6775 17.0037 20.5368 16.9509 20.3291 16.847Z"
                                            fill="white"
                                        />
                                    </svg>
                                </a>
                                {/* <a
                                    target="_blank"
                                    href="https://t.me/+79372770099"
                                    className="soc_item"
                                >
                                    <svg
                                        width="31"
                                        height="31"
                                        viewBox="0 0 31 31"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="15.8799"
                                            cy="15.7796"
                                            r="15"
                                        />
                                        <path
                                            d="M22.4361 7.98121C22.2287 7.99682 22.025 8.04713 21.8331 8.1302H21.8306C21.6464 8.2057 20.7706 8.58654 19.4392 9.1638L14.6682 11.241C11.2448 12.7309 7.87947 14.1982 7.87947 14.1982L7.91954 14.1821C7.91954 14.1821 7.68752 14.261 7.44516 14.4327C7.29543 14.5312 7.16659 14.66 7.06643 14.8115C6.94751 14.9919 6.85185 15.2678 6.8874 15.5531C6.94557 16.0355 7.24804 16.3248 7.46519 16.4845C7.68494 16.6462 7.89434 16.7217 7.89434 16.7217H7.89951L11.0554 17.8207C11.1969 18.2904 12.0171 21.0779 12.2142 21.72C12.3306 22.1035 12.4437 22.3433 12.5852 22.5264C12.6537 22.6199 12.7339 22.6981 12.8301 22.7609C12.8802 22.791 12.9336 22.8148 12.9891 22.8317L12.9568 22.8237C12.9665 22.8264 12.9743 22.8344 12.9814 22.8371C13.0072 22.8444 13.0247 22.8471 13.0576 22.8524C13.5572 23.0088 13.9586 22.6881 13.9586 22.6881L13.9812 22.6694L15.8445 20.9155L18.9674 23.3923L19.0385 23.4237C19.6894 23.719 20.3486 23.5546 20.6969 23.2647C21.0479 22.9727 21.1843 22.5992 21.1843 22.5992L21.2069 22.5391L23.6202 9.75844C23.6887 9.44308 23.7061 9.14777 23.6305 8.86114C23.5525 8.57105 23.3725 8.32156 23.1257 8.16161C22.9186 8.0314 22.6783 7.96855 22.4361 7.98121ZM22.3709 9.35088C22.3683 9.39297 22.376 9.38829 22.3579 9.46914V9.47648L19.9673 22.1242C19.9569 22.1422 19.9395 22.1816 19.8916 22.221C19.8412 22.2625 19.8012 22.2885 19.5911 22.2023L15.7715 19.175L13.4642 21.3491L13.9489 18.1488L20.1896 12.1356C20.4468 11.8884 20.3609 11.8363 20.3609 11.8363C20.379 11.533 19.9724 11.7475 19.9724 11.7475L12.1031 16.7872L12.1005 16.7738L8.32865 15.4609V15.4582L8.31896 15.4562C8.32557 15.454 8.33205 15.4513 8.33835 15.4482L8.35903 15.4375L8.37907 15.4302C8.37907 15.4302 11.7469 13.963 15.1704 12.473C16.8844 11.7267 18.6113 10.9751 19.9395 10.3952C20.7272 10.0524 21.5156 9.71167 22.3049 9.37292C22.3579 9.35154 22.3327 9.35154 22.3709 9.35154V9.35088Z"
                                            fill="white"
                                        />
                                    </svg>
                                </a> */}
                            </div>
                        </li>
                        <li>
                            <a
                                claccname="tel t20"
                                href="tel:+ 79372770099"
                            >
                                <b>+ 7 (937) 277-00-99</b>
                            </a>
                        </li>
                    </ul>
                </nav>
            </Container>
        </footer>
    );
}
